import { render, staticRenderFns } from "./Waybill.vue?vue&type=template&id=52d5606c&scoped=true"
import script from "./Waybill.vue?vue&type=script&lang=js"
export * from "./Waybill.vue?vue&type=script&lang=js"
import style0 from "./Waybill.vue?vue&type=style&index=0&id=52d5606c&prod&lang=scss&scoped=true"
import style1 from "./Waybill.vue?vue&type=style&index=1&id=52d5606c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5606c",
  null
  
)

export default component.exports